import { Component } from "react";
import { connect } from "react-redux";
import ManagerSideBar from "./managerSideBar";
import { Outlet } from "react-router";
import { Navigate } from "react-router";
class Manager extends Component {
  render() {
    // if (!this.props.isAuthenticated) return <Navigate to="/login" replace />;
    return (
      <div>
        <ManagerSideBar />

        <div className="container-fluid p-3">
          <Outlet />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({
  isAuthenticated: state.userState.isAuthenticated,
});
export default connect(mapStateToProps, mapDispatchToProps)(Manager);

// import { Component } from "react";
// import { connect } from "react-redux";
// class Manager extends Component {
//   render() {
//     return <div>Manager</div>;
//   }
// }

// const mapDispatchToProps = {};
// const mapStateToProps = (state) => ({});
// export default connect(mapStateToProps, mapDispatchToProps)(Manager);
